export default {
  5: 'voll und ganz',
  4: 'weitgehend',
  3: 'teils / teils',
  2: 'selten',
  1: 'überhaupt nicht'
}
